"use strict";

const EnhancedString = {
    ucfirst(data){
        return data.charAt(0).toUpperCase() + data.slice(1);
    },
    lcfirst(data){
        return data.charAt(0).toLowerCase() + data.slice(1);
    },
    stripDiacritics(v) {
        var patternLetters = new RegExp("[äáàâéèêěíýóòôöüůúùûťďňščřžĺÄÁÀÂÉÈÊĚÍÝÓÒÔÖÜŮÚÙÛŤĎŇŠČŘŽĹß]", "g");
        var lookupLetters = {
            "ä": "a", "á": "a", "à": "a", "â": "a",
            "é": "e", "è": "e", "ê": "e", "ě": "e",
            "í": "i", "ý":"y",
            "ó": "o", "ò": "o", "ô": "o", "ö": "o",
            "ü": "u", "ů":"u", "ú": "u", "ù": "u", "û": "u",
            "ť": "t", "ď": "d", "ň": "n",
            "š":"s","č":"c","ř":"r","ž":"z",
            "ĺ":"l",
            "Ä": "A", "Á": "A", "À": "A", "Â": "A",
            "É": "E", "È": "E", "Ê": "E", "E": "Ě",
            "Í": "I", "Ý":"Y",
            "Ó": "O", "Ò": "O", "Ô": "O", "Ö": "O",
            "Ü": "U", "Ů":"U", "Ú": "U", "Ù": "U", "Û": "U",
            "Ť": "T", "Ď": "D", "Ň": "N",
            "Š":"S","Č":"C","Ř":"R","Ž":"Z",
            "Ĺ":"L",
            "ß": "s"
        };
        var letterTranslator = function(match) {
            return lookupLetters[match] || match;
        };
        return v.replace(patternLetters, letterTranslator);
    },
    toString(data){
        var ret = "";
        if(data instanceof Array){
            data.forEach(function(part){
                ret = ret + EnhancedString.toString(part);
            }.bind(this))
        } else if(typeof data === "string") {
            if(typeof data.trim === "function") {
                ret = data.trim();
            }else{
                ret = data.replace(/^\s+|\s+$/gm,'');
            }
        }else{
            ret = "";
        }
        return ret;
    },
    regExpEscape(str) {
        var specials = [
            '/', '.', '*', '+', '?', '|',
            '(', ')', '[', ']', '{', '}', '\\'
        ];
        var sRE = new RegExp('(\\' + specials.join('|\\') + ')', 'g');
        return str.replace(sRE, '\\$1');
    }
};

class MenuFilter  {
    constructor (inputSelector, dataSelector, options) {
        this.inputSelector = inputSelector || '.menu-search input';
        this.dataSelector = dataSelector || '#vut-menu a';
        // aktualne vyheldane polozky
        this.filtered = [];
        this.filteredText = "";
        this.active=-1;
        this.isOpen = false;
        this.keyMap = {
            ENTER: 13,
            ESC: 27,
            UP: 38,
            DOWN: 40
        };
        this.options = Object.assign({
            minLength: 2,
            help : '#menu-search-help'
        }, options);

        // nacteni vsech potomku nad kterymi se pracuje
        // this.elements = $(this.dataSelector);
        var tmp = document.querySelectorAll(this.dataSelector);
        this.elements = Array.prototype.slice.call(tmp);

        // odchyceni udalosti

        this.input = document.querySelector(this.inputSelector);
        this.resetBtn = document.querySelector('.search-reset');
        this.container  = document.querySelector(this.options.help);
        this.focusElemInfo = document.querySelector('.menu-search');

        if (!this.input) return; 

        if(!this.container){
            // neni misto pro vykresleni napoved = > vygenrujeme
            var container = document.createElement('div');
            container.id= this.options.help.substring(1);
            container.classList.add("hidden");
            // vlozeni za input
            this.input.parentNode.insertBefore(container, this.input.nextSibling);
            this.container = container;
        }
        this.containerContent = document.createElement('div');
        this.containerContent.id="resizable-content";
        this.container.appendChild(this.containerContent);
        this._bindEventListeners()

    };

    handleEvent (e){
        switch(e.type){
            case "click":
                this.input.focus();
                if (document.querySelector(".vut-sidebar-collapsed")) {document.querySelector(".vut-sidebar-collapsed").classList.add("vut-sidebar-collapsed-search")}
                break;
            case "focus":
                this.searchMenu(""+e.target.value);
                this._displayResetBtn();
                this.focusElemInfo.classList.add('focus');
                //if (document.querySelector(".vut-sidebar-collapsed")) {document.querySelector(".vut-sidebar-collapsed").classList.add("vut-sidebar-collapsed-search")}
                break;
            case "keyup":
                switch(e.keyCode){
                    case this.keyMap.ENTER:
                        if(this.filtered.length>this.active && this.active>=0){
                            if(this.filtered[this.active]){
                                // existuej aktivni prvek
                                window.location = this.filtered[this.active].getAttribute("href")
                            }
                        }
                        break;
                    case this.keyMap.ESC:
                        this.active = -1;
                        this.filtered = [];
                        e.target.value = "";
                        this.hide();
                        break;
                    case this.keyMap.DOWN:
                        this.move(+1);
                        break;
                    case this.keyMap.UP:
                        this.move(-1);
                        break;
                    default:
                        this.active = -1;
                        this.searchMenu(""+e.target.value);
                        this.move(+1);

                        break;
                }
                this._displayResetBtn();
                if (document.querySelector(".vut-sidebar-collapsed")) {document.querySelector(".vut-sidebar-collapsed").classList.add("vut-sidebar-collapsed-search")}
                break;
        }
    };

    searchMenu(text){
        this.filteredText = text;
        this.filtered = [];
        if(text.length >= this.options.minLength) {
            var regular= new RegExp(EnhancedString.regExpEscape(EnhancedString.stripDiacritics(text)), 'i');
            this.elements.forEach(function (el) {
                if(el.getAttribute("href").length<=1){
                    // odfiltrovany atributy ktere nemaji href
                    return;
                }



                var searchText = EnhancedString.toString(el.textContent+(el.dataset.keywords?' '+el.dataset.keywords:''));
                var searchString = EnhancedString.stripDiacritics(searchText);
                if( !searchString.match(regular)){
                    return;
                }
                var isFiltered = this.filtered.filter(function(item){
                   return EnhancedString.toString(item.textContent) == searchText;
                });
                if (isFiltered.length == 0){
                    // jeste nebyl vyfiltrovan
                    this.filtered.push(el);
                }



            }.bind(this))
        }

        if (this.filtered.length > 0) {
            // jsou vyhledane elementy
            this.renderElements();
            this.show();
        }else{
            this.hide();
        }
    };
    
    move(step){
        this.active = this.active + step;
        this.active = Math.max(0, this.active );
        this.active = Math.min(this.filtered.length-1, this.active);
        this.renderElements();
    };
    
    renderElements(){
        // smaze se predchozi obsah
        this.containerContent.innerHTML = '';
        //this.container.html("");
        this.filtered.forEach(function(element, k){
            var newElement = document.createElement('a');
            if(k==this.active){
                newElement.classList.add('active');
            }
            newElement.href=element.getAttribute("href");
            newElement.innerHTML = this.hightlight(element.textContent);
            this.containerContent.insertBefore(newElement, null);
        }.bind(this))

    };
    
    hightlight (data){
        var label = EnhancedString.toString(data);
        var lastPos = 0;
        var positions = [];
        var normalizeLabel = EnhancedString.stripDiacritics(label);
        var normalizeTerm = EnhancedString.stripDiacritics(this.filteredText);

        var replaceCallBack = function ( match ) {
            var result = normalizeLabel.substring(lastPos).search( EnhancedString.regExpEscape(match)   );
            positions.push(lastPos + result);
            lastPos = (lastPos + result + 1);
            return match;
        };

        normalizeLabel.replace(new RegExp("(?![^&;]+;)(?!<[^<>]*)(" + EnhancedString.regExpEscape(normalizeTerm)  + ")(?![^<>]*>)(?![^&;]+;)", "gi"), replaceCallBack);

        var ret = label;
        var part = [];
        var last = 0;
        var length = this.filteredText.length;
        positions.forEach(function(from){
            if(from>last){
                // pridame prvni nezvyrazneny dil
                part.push(ret.substr(last, from-last));
            }
            // pridame zvyrazneny dil
            part.push('<strong>'+ret.substr((from), length)+'</strong>');
            last = from+length;
        }.bind(this));

        if(last<label.length ){
            // pridame posledni cast
            part.push(ret.substr(last, label.length-last));
        }
        return part.join("");
    };
    
    hide(){
        if(this.container && !this.container.classList.contains('hidden')){
           this.container.style.height = "0";
           document.querySelector("#vut-menu")?.classList?.remove?.('vut-menu-fade'); // rozsviceni menu
           //this.container.classList.add('hidden');
        }
    };
    
    show(){
        var height;
        if(this.container.classList.contains('hidden')){
            this.container.classList.remove('hidden');
            height = this.containerContent.clientHeight;
            this.container.classList.add('hidden');
            // nastavi se vyska 0
            this.container.style.height = "0";
            this.container.classList.remove('hidden');
        }else{
            // aktualizuje se vyska obsahu
            height = this.containerContent.clientHeight;
        }

        // nastavi se vyska podle obsahu
        this.container.style.height = ""+height+"px";
        document.querySelector("#vut-menu").classList.add('vut-menu-fade'); // ztmaveni menu
    };
    
    _displayResetBtn(){
        if(this.input.value.length){
            this.resetBtn.classList.remove("hidden");
        }else{
            this.resetBtn.classList.add("hidden");
        }
    };

    _bindEventListeners(){
        // bindovani eventu
        this.input.addEventListener('keyup', this);
//        this.input.addEventListener('blur', this);
        this.input.addEventListener('focus', this);
        this.input.addEventListener('click', this);
        try {var i=this.input; i.parentNode.parentNode.addEventListener('click', function(){i.click()});} catch(e) {}
        this.resetBtn.addEventListener('click', this);
    }

};

let that;

window.addEventListener('DOMContentLoaded', ()=>{that = new MenuFilter()}, true);

['mousedown', 'touchstart'].forEach(event=>window.addEventListener(event, e=>{
    if (e.target?.closest?.('.vut-sidebar')) {
        return;
    }

    setTimeout(function(){
        that.hide();
        setTimeout(function(){
            that.resetBtn?.classList?.add?.("hidden");
        }, 50);
    }, 100);
    that.focusElemInfo?.classList?.remove?.('focus');
    document.querySelector(".vut-sidebar-collapsed")?.classList?.remove?.("vut-sidebar-collapsed-search");

}));